import { Stack } from "react-bootstrap";
import { Score } from "../../models/Score";
import { getTrendClass } from "../../helpers/renderHelper";


const ScoreTile = ({score}:{score?: Score}) => {

	const trendClass = getTrendClass(score?.trend, "fs-2")
	var leftMargin = 10 //score?.trend === TREND.NO_CHANGE ? 10 : 10
	const currentScore =  score?.currentScore
	const finalLeftMargin = ((currentScore ?? 0) > 99 ) ? 2 : leftMargin

	const fontSize =  ((currentScore ?? 0) > 99 ) ? '40px' : '50px'
	const fontMarginTop  =  ((currentScore ?? 0) > 99 ) ? -10 : -18

	return (
		<div className="col col-4" style={{paddingRight: "0.35rem", height: "5.0rem", }}>
			<div className="card tile w-100" style={{height: "5.0rem", margin: 0,  padding: 0, overflow:'hidden'}}>
				<div className="row g-0" style={{ color:'white', display:'flex'}}>
					<div className="col col-12 g-0 p-0 mb-0" style={{marginTop:3}}>Score</div>
					<div className="col col-12 fw-bold g-0 p-0 mt-0" style={{justifyContent:'center'}}>
						<Stack direction="horizontal" style={{justifyContent:'center', marginTop:fontMarginTop}}>
							 <div style={{fontSize:fontSize, marginLeft:finalLeftMargin}}>{ currentScore ?? '-' }</div> 
							<i className={trendClass} style={{marginLeft:5}} />
						</Stack>
					</div>
				</div>
			</div>
		</div>
	)
}

export default ScoreTile;